<template>
  <div class="my-barcode-display">
    <svg
      class="my-barcode-display__svg"
      :viewBox="`0 0 ${geometry.width} 112`"
      preserveAspectRatio="none"
      role="img"
      aria-label="회원 바코드 이미지"
      shape-rendering="crispEdges"
    >
      <rect :width="geometry.width" height="112" fill="#ffffff" />
      <rect
        v-for="(bar, index) in geometry.bars"
        :key="`${bar.x}-${index}`"
        :x="bar.x"
        :y="bar.y"
        :width="bar.width"
        :height="bar.height"
        fill="#17212b"
      />
    </svg>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  value: {
    type: String,
    required: true
  }
});

const QUIET_ZONE_WIDTH = 12;
const GENERATED_BAR_COUNT = 54;
const RANDOM_MODULUS = 2147483647;

// UI-only visualization: this is deterministic from the prop, but it does not implement
// a barcode standard and is not guaranteed to be scannable.
const geometry = computed(() => {
  const source = props.value || '0';
  let seed = 17;

  Array.from(source).forEach((character, index) => {
    seed = (seed * 131 + character.codePointAt(0) + index) % RANDOM_MODULUS;
  });

  let cursor = QUIET_ZONE_WIDTH;
  const bars = [];

  for (let index = 0; index < GENERATED_BAR_COUNT; index += 1) {
    seed = (seed * 48271) % RANDOM_MODULUS;
    const width = 1 + (seed % 3);

    seed = (seed * 48271) % RANDOM_MODULUS;
    const gap = 1 + (seed % 2);
    const isGuardBar =
      index < 2 ||
      index >= GENERATED_BAR_COUNT - 2 ||
      index === GENERATED_BAR_COUNT / 2 - 1 ||
      index === GENERATED_BAR_COUNT / 2;

    bars.push({
      x: cursor,
      y: isGuardBar ? 8 : 16,
      width,
      height: isGuardBar ? 96 : 84
    });
    cursor += width + gap;
  }

  return {
    bars,
    width: cursor + QUIET_ZONE_WIDTH
  };
});
</script>

<style scoped>
.my-barcode-display {
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  padding: 10px 8px;
  background: #ffffff;
  border: 1px solid #e6e8eb;
  border-radius: 10px;
}

.my-barcode-display__svg {
  display: block;
  width: 100%;
  height: clamp(132px, 38vw, 176px);
}
</style>
